'use client';

import { CheckOutlined } from '@mui/icons-material';
import { DialogContent, MenuItem, Typography } from '@mui/material';

import { styled } from '../../styles';

export const SelectMenuItem = styled(MenuItem)(({ theme }) => ({
  height: 44,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const SelectItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const SelectItemLabel = styled(Typography)(
  () =>
    ({
      flex: 1,
      textAlign: 'start',
    } as const),
);

export const CheckIcon = styled(CheckOutlined)(({ theme }) => ({
  width: 24,
  height: 24,
  color: theme.palette.primary.main,
}));

export const SelectMenuApplyButtonContainer = styled.div(({ theme }) => ({
  padding: theme.spacing(2, 2, 12, 2),
}));

export const SelectGhostMobileDialogContent = styled(DialogContent)(() => ({
  padding: 0,
}));
